// extracted by mini-css-extract-plugin
export default {"configContainer":"Configuration_configContainer__4YcVt","volumenNumber":"Configuration_volumenNumber__lse3S","optionName":"Configuration_optionName__MMQ+P"};